export const LOCALES = ['es', 'en'] as const
export type LandingLocale = (typeof LOCALES)[number]
export const DEFAULT_LOCALE: LandingLocale = 'es'
export const EN_PREFIX = '/en'

/** Per-locale public URL slug pair for bilingual articles. */
export type LocalizedSlugs = { es: string; en: string }

/** ES section segment → EN segment (translated public URLs). */
export const ES_TO_EN_SECTION: Record<string, string> = {
    aprender: 'learn',
    'actualidad-hostelera': 'hospitality-news',
    autores: 'authors',
}

export const EN_TO_ES_SECTION: Record<string, string> = Object.fromEntries(
    Object.entries(ES_TO_EN_SECTION).map(([es, en]) => [en, es]),
)

export function isLandingLocale(value: string): value is LandingLocale {
    return (LOCALES as readonly string[]).includes(value)
}
